export const cdnEndpoints = (cdnBaseUrl: string) => {
  return {
    santi: cdnBaseUrl + 'common/images/santi-chat.svg',
  };
};
